export * from './delete-honorar-vereinbarung.component';
export * from './delete-honorar-vereinbarung.component.module';